export default __webpack_public_path__ + "navigation-examples-building-extrusion-thumbnail-v1-480-65f147182941f80c3cba7d9d5628c0ad.png";